<template>
  <div>
    <form
      class="table-filters"
      autocomplete="off"
      @submit.prevent="$emit('search')"
    >
      <v-row>
        <v-col
          v-for="(it, i) in filters"
          :key="i"
          :cols="it.cols ? it.cols : '2'"
        >
          <div class="input-block input-block_white">
            <label
              class="input-block__label"
              :class="{'required': it.required || (it.requiredForSupplier && !business)}"
            >
              {{ it.label }}
            </label>
            <template v-if="it.type === 'date'">
              <div class="input-block input-block_white">
                <date-picker
                  v-model="it.value"
                  hide-details
                />
              </div>
            </template>
            <template v-else-if="it.type === 'select'">
              <v-select
                v-model="it.value"
                :items="it.options"
                item-text="text"
                item-value="value"
                hide-details
                clearable
                solo
              />
            </template>
            <v-text-field
              v-else-if="(it.key === 'supplierAsdb' || it.key === 'supplier') && !business"
              :value="user ? user.asdb : ''"
              class="text--disabled"
              hide-details
              disabled
              solo
            />
            <v-select
              v-else-if="supplier && it.key === 'plant' && !business"
              v-model="it.value"
              :items="supplier.plants"
              item-text="plant"
              item-value="plant"
              hide-details
              solo
            />
            <v-select
              v-else-if="it.key === 'role'"
              v-model="it.value"
              :items="roles"
              multiple
              small-chips
              hide-details
              solo
              class="table-filters__role"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  {{ `+${it.value.length - 1} ${$t('common.more')}` }}
                </span>
              </template>
            </v-select>
            <v-text-field
              v-else-if="it.type === 'number'"
              v-model="it.value"
              type="number"
              hide-details
              solo
            />
            <v-text-field
              v-else
              v-model="it.value"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col
          :key="filters.length"
          :cols="2"
        >
          <div class="input-block input-block_white">
            <v-btn
              outlined
              type="submit"
              large
              class="table-filters__search-button"
              :disabled="!isValid"
            >
              {{ $t('common.search') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </form>
    <transition
      name="layout-fade"
      mode="out-in"
    >
      <div
        v-if="noItemsFound"
        class="h4 text-center"
      >
        {{ $t('common.no_data') }}
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DatePicker from '@/components/common/DatePicker.vue';
import { contactRoles } from '@/utils/enums';

export default {
  name: 'TableFilters',

  components: {
    DatePicker,
  },

  props: {
    filters: {
      type: Array,
      required: true,
    },
    noItemsFound: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['user', 'supplier']),
    ...mapGetters(['business']),

    isValid() {
      return Array.from(Object.values(
        this.filters.filter((it) => it.required || (it.requiredForSupplier && !this.business)),
      )).every((it) => it.value);
    },

    roles() {
      return contactRoles.map((role) => ({
        value: role,
        text: this.$t(`enums.supplier_notification_roles.${role}`),
      }));
    },
  },

  created() {
    if (!this.business) {
      this.forceASDB();
    }
  },

  methods: {
    forceASDB() {
      const supplierAsdb = this.filters.find((it) => it.key === 'supplierAsdb');
      if (supplierAsdb) {
        supplierAsdb.value = this.user.asdb;
      }

      const supplier = this.filters.find((it) => it.key === 'supplier');
      if (supplier) {
        supplier.value = this.user.asdb;
      }

      const plant = this.filters.find((it) => it.key === 'plant');
      if (plant) {
        const [plantData] = this.supplier.plants;
        plant.value = (plantData || {}).plant;
      }

      const seller = this.filters.find((it) => it.key === 'seller');
      if (seller) {
        seller.value = this.supplier.seller || this.user.asdb;
      }

      const buyer = this.filters.find((it) => it.key === 'buyer');
      if (buyer) {
        buyer.value = this.$config.defaultBuyer;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .table-filters {
    padding: 30px;
    margin-bottom: 30px;
    background: white;
    border-radius: 5px;

    &__form {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      margin-bottom: 20px;
    }

    &__role {
      width: 500px;
    }

    &__price-type {
      width: 196px;
    }

    &__search-button {
      position: absolute;
      bottom: 14px;
    }
  }
</style>
